export const AboutHeroText = {
  en: {
    preTitle: "About",
    name: "Maria Pooley",
    subtitle: "Business Coach • Advisor • Founder of Maria Advisory",
    shortIntro:
      "Helping business owners grow with clarity, structure, and measurable results.",
  },

  vi: {
    preTitle: "Giới thiệu",
    name: "Maria Pooley",
    subtitle:
      "Chuyên gia huấn luyện kinh doanh • Cố vấn • Nhà sáng lập Maria Advisory",
    shortIntro:
      "Đồng hành cùng doanh nghiệp phát triển với chiến lược rõ ràng, cấu trúc và hiệu quả đo lường được.",
  },
};

export const quoteAboutText = {
  en: {
    title:
      "At Maria Advisory, growth is not based on assumptions. It is measured, managed, and delivered.",
    body: "If you are ready to grow profitably through clear strategy, disciplined execution, and ROI-driven decision-making, Maria Pooley and Maria Advisory provide the expertise, structure, and accountability to support your next stage of growth.",
  },

  vi: {
    title:
      "Tại Maria Advisory, tăng trưởng không dựa trên giả định. Mọi thứ được đo lường, quản lý và tạo ra kết quả.",
    body: "Nếu bạn sẵn sàng tăng trưởng bền vững thông qua chiến lược rõ ràng, thực thi kỷ luật và các quyết định dựa trên ROI, Maria Pooley và Maria Advisory sẽ mang đến chuyên môn, cấu trúc và sự đồng hành để hỗ trợ giai đoạn phát triển tiếp theo của bạn.",
  },
};

export const missionAboutText = {
  en: {
    title: "Successful Business Strategy & Growth",
    description:
      "For business owners who want to boost sales, restructure, re-energize, and create a clear plan for sustainable growth.",
  },

  vi: {
    title: "Chiến lược & Tăng trưởng Doanh nghiệp Bền vững",
    description:
      "Dành cho các chủ doanh nghiệp muốn tăng doanh thu, tái cấu trúc, làm mới năng lượng và xây dựng kế hoạch rõ ràng cho tăng trưởng bền vững.",
  },
};

export const aboutMariaText = {
  en: {
    title: "About Maria Pooley & Maria Advisory",

    intro: [
      "Maria Pooley is a seasoned business coach, advisor, and operations expert, and the founder of Maria Advisory. She partners with business owners, leaders, and organisations to drive growth with clarity, structure, and measurable return on investment.",
      "With over 20 years of international experience across export/import, real estate, and business operations, Maria brings practical, hands-on expertise in leadership, operational efficiency, and performance improvement.",
      "Her work spans Vietnam, Thailand, Myanmar, Cambodia, Malaysia, China, Australia, and New Zealand, giving her a deep understanding of diverse markets, cultures, and business systems.",
      "In today’s fast-paced business world, organisations often invest heavily in sales, marketing, and operations without knowing what truly drives results. Maria Advisory helps businesses move beyond assumptions by creating structured growth strategies, performance tracking systems, and ROI-focused decision-making frameworks.",
    ],

    highlight:
      "At Maria Advisory, growth isn’t left to chance — it’s measured, managed, and delivered.",

    body: [
      "Maria works closely with business owners and leadership teams through a structured coaching and training process, identifying core challenges, removing operational bottlenecks, and unlocking higher productivity and profitability.",
      "She helps organisations implement practical growth strategies, KPI frameworks, and reporting systems that improve performance across sales, marketing, and operations.",
      "If you’re ready to grow profitably through clear strategy, disciplined execution, and ROI-driven decisions, Maria Pooley and her team provide the expertise, structure, and accountability to take your business to the next level.",
    ],

    closingTitle:
      "Grow Profitably. Lead with Clarity. Achieve Measurable Results.",
    closingText:
      "Maria Pooley helps business owners and leaders unlock growth, remove bottlenecks, and maximize ROI through practical strategies, structured coaching, and performance-driven solutions.",

    cta: "Transform your business today — join Maria’s world and start achieving your Goals & your Dreams.",
  },

  vi: {
    title: "Về Maria Pooley & Maria Advisory",

    intro: [
      "Maria Pooley là một chuyên gia huấn luyện kinh doanh, cố vấn chiến lược và chuyên gia vận hành giàu kinh nghiệm, đồng thời là nhà sáng lập Maria Advisory. Cô đồng hành cùng các chủ doanh nghiệp, lãnh đạo và tổ chức để thúc đẩy tăng trưởng với sự rõ ràng, cấu trúc và hiệu quả đầu tư đo lường được.",
      "Với hơn 20 năm kinh nghiệm quốc tế trong lĩnh vực xuất nhập khẩu, bất động sản và vận hành doanh nghiệp, Maria mang đến góc nhìn thực tiễn sâu sắc về lãnh đạo, tối ưu vận hành và cải thiện hiệu suất.",
      "Cô đã làm việc tại Việt Nam, Thái Lan, Myanmar, Campuchia, Malaysia, Trung Quốc, Úc và New Zealand, giúp cô hiểu rõ sự đa dạng về thị trường, văn hoá và hệ thống kinh doanh.",
      "Trong môi trường kinh doanh nhanh và cạnh tranh ngày nay, nhiều doanh nghiệp đầu tư mạnh vào bán hàng, marketing và vận hành nhưng không thực sự biết điều gì tạo ra kết quả. Maria Advisory giúp doanh nghiệp vượt qua suy đoán bằng cách xây dựng chiến lược tăng trưởng có cấu trúc, hệ thống theo dõi hiệu suất và tư duy ra quyết định dựa trên ROI.",
    ],

    highlight:
      "Tại Maria Advisory, tăng trưởng không dựa vào may mắn — mà được đo lường, quản lý và tạo ra kết quả.",

    body: [
      "Maria làm việc trực tiếp với chủ doanh nghiệp và đội ngũ lãnh đạo thông qua quy trình huấn luyện và đào tạo có cấu trúc, giúp xác định vấn đề cốt lõi, loại bỏ điểm nghẽn vận hành và mở ra mức độ năng suất và lợi nhuận cao hơn.",
      "Cô hỗ trợ doanh nghiệp xây dựng chiến lược tăng trưởng thực tế, triển khai hệ thống KPI và báo cáo, đồng thời cải thiện hiệu quả kinh doanh trong bán hàng, marketing và vận hành.",
      "Nếu bạn sẵn sàng tăng trưởng bền vững thông qua chiến lược rõ ràng, thực thi kỷ luật và quyết định dựa trên ROI, Maria Pooley và đội ngũ sẽ mang đến chuyên môn, cấu trúc và sự đồng hành để đưa doanh nghiệp của bạn lên một tầm cao mới.",
    ],

    closingTitle:
      "Tăng trưởng bền vững. Lãnh đạo rõ ràng. Đạt kết quả đo lường được.",
    closingText:
      "Maria Pooley giúp chủ doanh nghiệp và lãnh đạo khai phá tăng trưởng, loại bỏ điểm nghẽn và tối đa hóa ROI thông qua chiến lược thực tiễn, huấn luyện có cấu trúc và giải pháp dựa trên hiệu suất.",

    cta: "Chuyển đổi doanh nghiệp của bạn ngay hôm nay — tham gia cùng Maria và bắt đầu đạt được mục tiêu và ước mơ của bạn.",
  },
};

export const aboutButtons = {
  en: {
    book: "Book Consultation",
  },
  vi: {
    book: "Đặt lịch tư vấn",
  },
};

export const discussMariaAbout = {
  en: {
    quote:
      "Prefer to talk first? Session 1 is always FREE —no commitment, no pressure.",

    name: "Maria Pooley",

    role: "Founder, Maria Advisory • Business Coach & Advisor",

    button1: "Discuss with Maria",
  },

  vi: {
    quote:
      "Muốn trao đổi trước? Buổi tư vấn đầu tiên luôn MIỄN PHÍ — không ràng buộc, không áp lực",

    name: "Maria Pooley",

    role: "Nhà sáng lập Maria Advisory • Chuyên gia Tư vấn Doanh nghiệp",

    button1: "Trao đổi với Maria",
  },
};
